import './css/styles.scss';

function senasteInlaggInit() {}

senasteInlaggInit();
